<template>
	<transition 
			appear
			:appear-active-class="$_timeline_stylePageAnimation()">
		<template v-if="initialized_">
			<v-container 
					id="_timeline_top"
					class="customVContainer container_"
					:style="$_timeline_stylePageContainerStyle()"
					fluid>
				<template v-if="!$_timeline_stateAppIsMobileScreen">
					<v-navigation-drawer
							class="navigationDrawer_"
							app 
							clipped 
							permanent 
							:dark="$_timeline_styleNavigationDrawerDark"
							:light="$_timeline_styleNavigationDrawerLight"
							:right="$_timeline_styleNavigationDrawerRight">
						<searchbar-list />
						<chat-list />
					</v-navigation-drawer>
				</template>
				<template v-for="(messageVals, messageKey) in sortObject(messages_, 'datetime', 'desc')">
					<v-timeline
							:key="`header-${messageKey}`"

							v-show="$_timeline_filterMessage(messageVals)"

							class="timelineHead_"
							dense
							:dark="$_timeline_styleTimelineDark"
							:itemColor="$_timeline_styleTimelineItemColor"
							:itemIconColor="$_timeline_styleTimelineItemIconColor"
							:itemLarge="$_timeline_styleTimelineItemLarge"
							:itemSmall="$_timeline_styleTimelineItemSmall"
							:light="$_timeline_styleTimelineLight">
						<v-timeline-item class="timelineItem_"
								:large="messageVals['sender_uid'] != $_timeline_currentUserUid"
								:small="messageVals['sender_uid'] == $_timeline_currentUserUid">
							<template v-slot:icon>
								<template v-if="messageVals['sender_uid'] != $_timeline_currentUserUid">
									<template v-if="messageVals['chat_code'] == null">
										<v-icon>person</v-icon>
									</template>
									<template v-else>
										<v-icon>group</v-icon>
									</template>
								</template>
							</template>
							<v-row no-gutters>
								<v-col>
									<timeline-message-header-card :message="messageVals" />
								</v-col>
								<template v-if="debugMode">
									<v-col cols="auto">
										<v-dialog>
											<template v-slot:activator="{ on }">
												<v-btn	class="customVBtn"
														color="error"
														icon
														v-on="on">
													<v-icon>error</v-icon>
												</v-btn>
											</template>
											<v-card class="customVCard">
												<v-row class="px-2">
													<v-col>
														<v-alert color="error" outlined>
															<pre	class="prettyprint caption pretty_ error_"
																	v-text="messageVals" />
														</v-alert>
													</v-col>
												</v-row>
											</v-card>
										</v-dialog>
									</v-col>
								</template>
							</v-row>
						</v-timeline-item>
					</v-timeline>
					<!-- message body -->
					<v-timeline
							:key="`body-${messageKey}`"

							v-show="$_timeline_filterMessage(messageVals)"

							class="timelineBody_"
							dense align-top
							:dark="$_timeline_styleTimelineDark"
							:itemColor="$_timeline_styleTimelineItemColor"
							:itemIconColor="$_timeline_styleTimelineItemIconColor"
							:itemLarge="$_timeline_styleTimelineItemLarge"
							:itemSmall="$_timeline_styleTimelineItemSmall"
							:light="$_timeline_styleTimelineLight">
						<v-timeline-item class="timelineItem_" hide-dot>
							<timeline-message-body-card :message="messageVals" />
						</v-timeline-item>
					</v-timeline>
					<!-- buttons -->
					<v-timeline
							:key="`buttons-${messageKey}`"

							v-show="$_timeline_filterMessage(messageVals)"

							class="timelineButton_"
							dense align-top
							:dark="$_timeline_styleTimelineDark"
							:itemColor="$_timeline_styleTimelineItemColor"
							:itemIconColor="$_timeline_styleTimelineItemIconColor"
							:itemLarge="$_timeline_styleTimelineItemLarge"
							:itemSmall="$_timeline_styleTimelineItemSmall"
							:light="$_timeline_styleTimelineLight">
						<v-timeline-item class="timelineItem_" hide-dot>
							<v-row dense>
								<template v-if="messageVals['sender_uid'] != $_timeline_currentUserUid">
									<v-col cols="auto">
										<v-btn	class="customVBtn"
												:block="$_timeline_styleReplyButtonBlock"
												:color="$_timeline_styleReplyButtonColor"
												:dark="$_timeline_styleReplyButtonDark"
												:depressed="$_timeline_styleReplyButtonDepressed"
												:elevation="$_timeline_styleReplyButtonElevation"
												:large="$_timeline_styleReplyButtonLarge"
												:light="$_timeline_styleReplyButtonLight"
												:outlined="$_timeline_styleReplyButtonOutlined"
												:rounded="$_timeline_styleReplyButtonRounded"
												:small="$_timeline_styleReplyButtonSmall"
												:text="$_timeline_styleReplyButtonFlat"
												@click="$_timeline_reply(messageVals)">
											<v-row align="center" dense>
												<v-col cols="auto">
													<v-icon>reply</v-icon>
												</v-col>
												<v-col cols="auto">
													<span	class="overline"
															v-text="$_timeline_langReplyButton" />
												</v-col>
											</v-row>
										</v-btn>
									</v-col>
								</template>
							</v-row>
						</v-timeline-item>
					</v-timeline>
				</template>
			</v-container>
		</template>
		<template v-else>
			<v-row class="customVRow">
				<v-col cols="12" class="center">
					<progress-circular />
				</v-col>
			</v-row>
		</template>
	</transition>
</template>

<script>
	export default {
		name: 'Timeline',
		data(){
			return {
				pageName_: 'timeline',
				pageType_: 'timeline',

				initialized_: false,

				messages_: {
					dummy1: {
						datetime: new Date(),

						sender_uid: 'admin',
						sender_name: 'Admin',

						chat_code: 'dummy',
						chat_name: 'Dummy',

						title: 'Dummy Message 1',
						text: 'This is a dummy message 1',
					},
					dummy2: {
						datetime: new Date(),

						senderUid: 'admin',
						senderName: 'Admin',

						title: 'Dummy Message 2',
						text: 'This is a dummy message 2'
					}
				},

				onLoading_: false
			}
		},
		computed: {
			// route
			$_timeline_routeName() {
				const self_ = this;
				const route_ = self_.$route
				return route_.name
			},
			// params
			$_timeline_params() {
				const self_ = this;
				const route_ = self_.$route
				return route_.params
			},
			$_timeline_paramsLimitCount() {
				const self_ = this;
				const params_ = self_.$_timeline_params;
				if(self_.isEmpty(params_)) { return null }
				return params_.limitCount
			},
			// cuurent user
			$_timeline_currentUserUid() {
				const self_ = this;
				return self_.getCurrentUser('uid')
			},
			// state
			$_timeline_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			$_timeline_statePageIsInitialized() {
				const self_ = this;
				const initialized_ = self_.getPageState('isInitialized')
				return initialized_[self_.pageName_]
			},
			$_timeline_stateComponentSearchbarList() {
				const self_ = this;
				return self_.getComponentState('searchbarList')
			},
			$_timeline_stateComponentSearchbarListStartDate() {
				const self_ = this;
				const component_ = self_.$_timeline_stateComponentSearchbarList;
				return component_.startDate
			},
			$_timeline_stateComponentSearchbarListEndDate() {
				const self_ = this;
				const component_ = self_.$_timeline_stateComponentSearchbarList;
				return component_.endDate
			},
			$_timeline_stateComponentSearchbarListWord() {
				const self_ = this;
				const component_ = self_.$_timeline_stateComponentSearchbarList;
				return component_.word
			},
			$_timeline_stateComponentSearchbarListTag() {
				const self_ = this;
				const component_ = self_.$_timeline_stateComponentSearchbarList;
				return component_.tag
			},
			// contents / inits
			$_timeline_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getPageContents(self_.pageName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_timeline_inits() {
				const self_ = this;
				return () => {
					return self_.getPageInits(self_.pageName_)
				}
			},
			// info
			$_timeline_infoContact() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.$_timeline_inits(), 'contact')
			},
			// lang
			$_timeline_langReplyButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_timeline_inits(), 'replyButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			// style
			$_timeline_stylePage() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.$_timeline_inits())) { return null }
					return self_.getInitsStyleVal(self_.$_timeline_inits(), 'page')
				}
			},
			$_timeline_stylePageAnimation() {
				const self_ = this;
				return () => {
					const page_ = self_.$_timeline_stylePage()
					if(self_.isFalse(page_)) { return null }
					return self_.getStylesVal(page_.animation)
				}
			},
			$_timeline_stylePageContainer() {
				const self_ = this;
				if(self_.isEmpty(self_.$_timeline_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_timeline_inits(), 'pageContainer')
			},
			$_timeline_stylePageContainerStyle() {
				const self_ = this;
				return () => {
					const page_ = self_.$_timeline_stylePageContainer;
					if(self_.isFalse(page_)) { return null }
					return self_.getStylesVal(page_.style)
				}
			},
			$_timeline_styleNavigationDrawer() {
				const self_ = this;
				if(self_.isEmpty(self_.$_timeline_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_timeline_inits(), 'navigationDrawer')
			},
			$_timeline_styleNavigationDrawerDark() {
				const self_ = this;
				const navigationDrawer_ = self_.$_tb_styleNavigationDrawer;
				if(self_.isFalse(navigationDrawer_)) { return null }
				return self_.getStylesVal(navigationDrawer_.dark)
			},
			$_timeline_styleNavigationDrawerLight() {
				const self_ = this;
				const navigationDrawer_ = self_.$_tb_styleNavigationDrawer;
				if(self_.isFalse(navigationDrawer_)) { return null }
				return self_.getStylesVal(navigationDrawer_.light)
			},
			$_timeline_styleNavigationDrawerRight() {
				const self_ = this;
				const navigationDrawer_ = self_.$_tb_styleNavigationDrawer;
				if(self_.isFalse(navigationDrawer_)) { return null }
				return self_.getStylesVal(navigationDrawer_.right)
			},
			$_timeline_styleTimeline() {
				const self_ = this;
				if(self_.isEmpty(self_.$_timeline_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_timeline_inits(), 'timeline')
			},
			$_timeline_styleTimelineDark() {
				const self_ = this;
				const timeline_ = self_.$_tb_styleTimeline;
				if(self_.isFalse(timeline_)) { return null }
				return self_.getStylesVal(timeline_.dark)
			},
			$_timeline_styleTimelineItemColor() {
				const self_ = this;
				const timeline_ = self_.$_tb_styleTimeline;
				if(self_.isFalse(timeline_)) { return null }
				return self_.getStylesVal(timeline_.itemColor)
			},
			$_timeline_styleTimelineItemIconColor() {
				const self_ = this;
				const timeline_ = self_.$_tb_styleTimeline;
				if(self_.isFalse(timeline_)) { return null }
				return self_.getStylesVal(timeline_.itemIconColor)
			},
			$_timeline_styleTimelineItemLarge() {
				const self_ = this;
				const timeline_ = self_.$_tb_styleTimeline;
				if(self_.isFalse(timeline_)) { return null }
				return self_.getStylesVal(timeline_.itemLarge)
			},
			$_timeline_styleTimelineItemSmall() {
				const self_ = this;
				const timeline_ = self_.$_tb_styleTimeline;
				if(self_.isFalse(timeline_)) { return null }
				return self_.getStylesVal(timeline_.itemSmall)
			},
			$_timeline_styleTimelineLight() {
				const self_ = this;
				const timeline_ = self_.$_tb_styleTimeline;
				if(self_.isFalse(timeline_)) { return null }
				return self_.getStylesVal(timeline_.light)
			},
			$_timeline_styleReplyButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.$_timeline_inits(), 'replyButton')
			},
			$_timeline_styleReplyButtonBlock() {
				const self_ = this;
				const replyButton_ = self_.$_timeline_styleReplyButton;
				if(self_.isFalse(replyButton_)) { return null }
				return self_.getStylesVal(replyButton_.block)
			},
			$_timeline_styleReplyButtonColor() {
				const self_ = this;
				const replyButton_ =self_.$_timeline_styleReplyButton;
				if(self_.isFalse(replyButton_)) { return null }
				return self_.getStylesVal(replyButton_.color)
			},
			$_timeline_styleReplyButtonDark() {
				const self_ = this;
				const replyButton_ = self_.$_timeline_styleReplyButton;
				if(self_.isFalse(replyButton_)) { return null }
				return self_.getStylesVal(replyButton_.dark)
			},
			$_timeline_styleReplyButtonDepressed() {
				const self_ = this;
				const replyButton_ = self_.$_timeline_styleReplyButton;
				if(self_.isFalse(replyButton_)) { return null }
				return self_.getStylesVal(replyButton_.depressed)
			},
			$_timeline_styleReplyButtonElevation() {
				const self_ = this;
				const replyButton_ = self_.$_timeline_styleReplyButton;
				if(self_.isFalse(replyButton_)) { return null }
				return self_.getStylesVal(replyButton_.elevation)
			},
			$_timeline_styleReplyButtonFlat() {
				const self_ = this;
				const replyButton_ = self_.$_timeline_styleReplyButton;
				if(self_.isFalse(replyButton_)) { return null }
				return self_.getStylesVal(replyButton_.flat)
			},
			$_timeline_styleReplyButtonLarge() {
				const self_ = this;
				const replyButton_ = self_.$_timeline_styleReplyButton;
				if(self_.isFalse(replyButton_)) { return null }
				return self_.getStylesVal(replyButton_.large)
			},
			$_timeline_styleReplyButtonLight() {
				const self_ = this;
				const replyButton_ = self_.$_timeline_styleReplyButton;
				if(self_.isFalse(replyButton_)) { return null }
				return self_.getStylesVal(replyButton_.light)
			},
			$_timeline_styleReplyButtonOutlined() {
				const self_ = this;
				const replyButton_ = self_.$_timeline_styleReplyButton;
				if(self_.isFalse(replyButton_)) { return null }
				return self_.getStylesVal(replyButton_.outlined)
			},
			$_timeline_styleReplyButtonRounded() {
				const self_ = this;
				const replyButton_ = self_.$_timeline_styleReplyButton;
				if(self_.isFalse(replyButton_)) { return null }
				return self_.getStylesVal(replyButton_.rounded)
			},
			$_timeline_styleReplyButtonSmall() {
				const self_ = this;
				const replyButton_ = self_.$_timeline_styleReplyButton;
				if(self_.isFalse(replyButton_)) { return null }
				return self_.getStylesVal(replyButton_.small)
			}
		},
		watch: {
			$route() { 
				const self_ = this;

				// initialize message & replace to timeline
				self_.$_timeline_updateRoute()
			}
		},
		created() {
			const self_ = this;
			// life cycle
			self_.createdPage(self_.pageName_)

			self_.$_timeline_setPageState()

			if(self_.$_timeline_stateIsInitialized) { 
				self_.initialized_ = true;
			} else {
				self_.$_timeline_initialize()
			}
		},
		beforeMount() {
			const self_ = this;
			self_.beforeMountPage(self_.pageName_)

			// initialize message & replace to timeline
			self_.$_timeline_updateRoute()
		},
		beforeDestroy() {
			const self_ = this;
			self_.beforeDestroyPage(self_.pageName_)
		},
		methods: {
			$_timeline_setPageState() {
				const self_ = this;

				self_.setPageState('name', self_.pageName_)
				self_.setPageState('type', self_.pageType_)
			},
			$_timeline_initialize() {
				const self_ = this;

				Promise.resolve().then(() => {
					return self_.initializePage(self_.pageName_, self_.pageType_)
				}).then(() => {
					return self_.$_timeline_initializeMessages()
				}).then(() => {
					self_.initialized_ = true;
				}).catch(error => {
/* error */			self_.logError('Error', '$_timeline_initialize()' ,error)
				})
			},
			$_timeline_filterMessage(message) {
				const self_ = this;

				let result_ = true;
				result_ = result_ && self_.$_timeline_filterMessageBySearchbar(message)
				result_ = result_ && self_.$_timeline_filterMessageByChatList(message)

				return result_
			},
			$_timeline_filterMessageBySearchbar(message) {
				const self_ = this;
				
				const searchbarList_ = self_.getComponentState('searchbarList')
				// search condition
				let time_ = true;
				let title_ = true;
				let text_ = true;
				let word_ = true;
				let tag_ = true;

				let result_ = false;
				let condition_ = false; // no search condition
				// start date & end date
				if(!self_.isEmpty(searchbarList_.startDate)) {
					time_ = time_ && self_.moment(message['datetime']) >= self_.moment(searchbarList_.startDate);
					condition_ = true;
				}
				if(!self_.isEmpty(searchbarList_.endDate)) {
					time_ = time_ && self_.moment(message['datetime']) <= self_.moment(searchbarList_.endDate);
					condition_ = true;
				}
				// word & tag
				if(!self_.isEmpty(searchbarList_.word)) {
					title_ = !self_.isFalse(message['title']) && message['title'].indexOf(searchbarList_.word) != -1;
					text_ = !self_.isFalse(message['text']) && message['text'].indexOf(searchbarList_.word) != -1;
					word_ = title_ || text_;
					condition_ = true;
				}
				if(!self_.isEmpty(searchbarList_.tag)) {
					tag_ = !self_.isEmpty(message['tag']) && !self_.isFalse(message['tag'].find(key => { return key == searchbarList_.tag }))
					condition_ = true;
				}

				result_ = time_ && word_ && tag_;

				return result_ || !condition_
			},
			$_timeline_filterMessageByChatList(message) {
				const self_ = this;

				const uid_ = self_.$_timeline_currentUserUid;

				const chatList_ = self_.getComponentState('chatList')
				const code_ = chatList_.code;
				const name_ = chatList_.name;
				const type_ = chatList_.type;

				if(self_.isFalse(code_)) { return true }

				let result_ = false;

				if(code_ == 'myChat') {
					result_ = message['chat_code'] == null && message['sender_uid'] == uid_ && message['to_uid'] == uid_;
				}
				else if(type_ == 'direct') {
					result_ = message['chat_code'] == null && ( message['sender_uid'] == code_ || message['to_uid'] == code_ )
				}
				else if(type_ == 'group') {
					result_ = message['chat_code'] == code_;
				}

				return result_
			},
			$_timeline_reply(message) {
				const self_ = this;
				// reset
				self_.resetMessageState()
				// to
				self_.setMessageState('toUid', message['sender_uid'])
				self_.setMessageState('toName', message['sender_name'])
				// page
				self_.setMessageState('pageName', 'timeline')
				self_.setMessageState('pageType', 'timeline')
				// chat
				self_.setMessageState('chatCode', message['chat_code'])
				self_.setMessageState('chatName', message['chat_name'])
				// title & text
				let title_ = 'Re:';
				if(!self_.isFalse(message['title'])) {
					title_ = title_ + message['title'];
				}
				self_.setMessageState('title', title_)
				self_.setMessageState('text', null)
				// attachment
				self_.setMessageState('attachmentFileUrl', null)
				// tag
				self_.setMessageState('tag', message['tag'])
				// quoted
				self_.setMessageState('quotedMessage', message)

				self_.setComponentState('showMessagebarFooter', true)
			},
			$_timeline_updateRoute() {
				const self_ = this;
				const router_ = self_.$router;

				// initialize message
				self_.$_timeline_initializeMessages()

				if(self_.$_timeline_routeName == 'timelineRefresh') { 
					router_.replace('/timeline')
				}
			},
			$_timeline_initializeMessages() {
				const self_ = this;
				const vuetify_ = self_.$vuetify;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.getMessages()
					}).then(result => {
						if(!self_.isEmpty(result)) { self_.messages_ = result }

						// if(self_.initialized_) { vuetify_.goTo('#_timeline_top') }

						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			}
		}
	}
</script>

<style scoped>
	.container_ {
		padding-bottom: 0 !important;
	}
	.navigationDrawer_ {
		z-index: 0 !important;
		max-height: calc(100% - 64px) !important;
	}
	.timelineHead_ {
		padding-top: 24px;
	}
	.timelineBody_ {
		padding-top: 4px;
	}
	.timelineButton_ {
		padding-top: 8px;
	}
	.timelineItem_ {
		padding-bottom: 0;
	}
	.v-timeline-item.timelineItem_ {
		display: flex;
		align-items: center;
	}
	.error_ {
		color: #ff5252;
	}
	.pretty_ {
		border: none;
	}
</style>
